import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import { selectHasScheduledCallbackUpcoming } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

type ModulesConfig = Record<string, { menu?: { callbacks?: boolean } } | undefined>

const useScheduleCallbackRailEntry = () => {
  const { t } = useTranslation()
  const { country: rawCountry } = useSelector(selectAuthData)
  const hasUpcoming: boolean = useSelector(selectHasScheduledCallbackUpcoming)
  const country = String(rawCountry || '').toLowerCase()
  const callbacksAllowed = (modulesConfig as ModulesConfig)[country]?.menu?.callbacks ?? false

  return {
    hidden: !callbacksAllowed,
    label: t('subscriptionTools:schedule_callback.schedule_button'),
    statusDotLabel: hasUpcoming ? t('common:callback_already_scheduled') : undefined,
  }
}

export default useScheduleCallbackRailEntry
